import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError, startGoogleLogin } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Account created");
      navigate("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-24">
      <h1 className="font-serif text-5xl tracking-tight mb-2">Create account</h1>
      <p className="text-[#666] mb-10">Join Nesta for a faster checkout and order history.</p>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <label className="text-xs uppercase tracking-luxe text-[#999]">Name</label>
          <input
            data-testid="register-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="w-full border-b border-[#1a1a1a] py-3 bg-transparent outline-none focus:border-b-2"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-luxe text-[#999]">Email</label>
          <input
            data-testid="register-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border-b border-[#1a1a1a] py-3 bg-transparent outline-none focus:border-b-2"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-luxe text-[#999]">Password</label>
          <input
            data-testid="register-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            className="w-full border-b border-[#1a1a1a] py-3 bg-transparent outline-none focus:border-b-2"
          />
        </div>
        {error && <p data-testid="register-error" className="text-[#b00020] text-sm">{error}</p>}
        <button
          data-testid="register-submit"
          disabled={loading}
          className="w-full bg-[#1a1a1a] text-white py-4 text-sm uppercase tracking-luxe hover:bg-[#333] transition-colors disabled:opacity-50"
        >
          {loading ? "Creating…" : "Create Account"}
        </button>
      </form>

      <div className="flex items-center gap-4 my-8">
        <div className="flex-1 h-px bg-[#e5e5e5]" />
        <span className="text-xs uppercase tracking-luxe text-[#999]">or</span>
        <div className="flex-1 h-px bg-[#e5e5e5]" />
      </div>
      <button
        data-testid="google-register-btn"
        onClick={startGoogleLogin}
        className="w-full flex items-center justify-center gap-3 border border-[#1a1a1a] py-4 text-sm uppercase tracking-luxe hover:bg-[#f5f5f0] transition-colors"
      >
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" />
        Continue with Google
      </button>

      <p className="text-sm text-[#666] mt-8 text-center">
        Already have an account?{" "}
        <Link to="/login" className="text-black underline">Sign in</Link>
      </p>
    </div>
  );
}
